import React, { Fragment, useEffect, useState } from "react";
import { Col, Container, Row } from "react-bs4grid";
import { Link } from "react-router-dom";
import Cookies from "js-cookie";

import axiosInstance from "../../apiPromises/axiosInstance";
import ResponsiveMenu from "../../common/ResponsiveMenu/ResponsiveMenu";
import MenuItem from "../../common/ResponsiveMenu/MenuItem";
import useAppState from "../../common/StateMachine/useAppState";

import "./header.scss";
import "./responsivemenu.scss";
import { useTranslation } from "react-i18next";

const Header = () => {
    const accountState = useAppState("account");
    const account = accountState.state;

    const [userProfile, setUserProfile] = useState({});
    const { t, i18n } = useTranslation();
    const [languageOption, setLanguageOption] = useState("");

    useEffect(() => {
        axiosInstance.get("/users/current").then(res => {
            setUserProfile(res.data);
        }).catch(err => {
            console.error("Error getting and setting user profile");
        });
        checkloc();
    }, []);

    function checkloc() {
        let storedlat = Cookies.get("plastX_lat");
        let storedlong = Cookies.get("plastX_long");
        if ((storedlong === undefined || storedlat === undefined)) {
            try {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(setByGeolocation);
                }
                else {
                    throw new Error("No access to geolocation API");
                }
            } catch {
                Cookies.set("plastX_lat", 0, { expires: 0.09 });
                Cookies.set("plastX_long", 0, { expires: 0.09 });
            }
        }
    }

    function setByGeolocation(position) {
        Cookies.set("plastX_lat", position.coords.latitude, { expires: 0.09 });
        Cookies.set("plastX_long", position.coords.longitude, { expires: 0.09 });
    }

    function changeLanguage(event) {
        if (event.target.value) {
            const v = event.target.value;
            setLanguageOption(v);
            setTimeout(() => i18n.changeLanguage(v), 200);
        }
    }

    function changeToEn() {
        setLanguageOption("en");
        i18n.changeLanguage("en");
    }
    function changeToHi() {
        setLanguageOption("hi");
        i18n.changeLanguage("hi");
    }
    function changeToTh() {
        setLanguageOption("th");
        i18n.changeLanguage("th");
    }
    function changeToMy() {
        setLanguageOption("my");
        i18n.changeLanguage("my");
    }
    function changeToCn() {
        setLanguageOption("cn");
        i18n.changeLanguage("cn");
    }

    return (
        <header className="header">
            <Container>
                <Row
                    alignItems="center"
                    justifyContent="center"
                    style={{ height: "80px" }}>
                    <Col w="auto" alignItems="center">
                        <Link to="/jobs/my-jobs">
                            <span>
                                <img className="logo" src="/logo-white.png" alt="plastx logo" />
                            </span>
                        </Link>
                    </Col>
                    <Col w="auto" alignItems="center" push="left">
                        <ResponsiveMenu
                            right
                            mobile={
                                <Fragment>
                                    {account.isLoggedIn && (
                                        <Fragment>
                                            <div className="avatar-section mobile">
                                                <img
                                                    src={userProfile.profilePhotoPath || "/default-profile-picture.jpg"}
                                                    alt="user profile avatar"
                                                />
                                                <h3>{account.account.fullName}</h3>
                                            </div>
                                            <MenuItem to="/user/my-profile">{t("viewProfile")}</MenuItem>
                                        </Fragment>
                                    )}
                                    <MenuItem to="/jobs/my-jobs">{t("jobs")}</MenuItem>
                                    <MenuItem external to="https://www.collect.plastx.co/send-help">{t("help")}</MenuItem>
                                    <br />
                                    <MenuItem>
                                        <div className="mobileLanguageHeader">{t("switchLang")}</div>
                                        <div className="mobileLanguage" value="en" onClick={changeToEn}>English</div>
                                        <div className="mobileLanguage" value="hi" onClick={changeToHi}>हिंदी</div>
                                        <div className="mobileLanguage" value="th" onClick={changeToTh}>ไทย</div>
                                        <div className="mobileLanguage" value="my" onClick={changeToMy}>Bahasa Melayu</div>
                                        <div className="mobileLanguage" value="cn" onClick={changeToCn}>简体中文</div>
                                    </MenuItem>
                                    <hr />
                                    {account.isLoggedIn && (
                                        <MenuItem to="/user/logout">{t("logout")}</MenuItem>
                                    )}
                                    {!account.isLoggedIn && (
                                        <MenuItem to="/user/login">Login or register</MenuItem>
                                    )}
                                </Fragment>
                            }
                            desktop={
                                <Fragment>
                                    <MenuItem to="/jobs/my-jobs">{t("jobs")}</MenuItem>
                                    <MenuItem external to="https://www.collect.plastx.co/send-help">{t("help")}</MenuItem>
                                    {account.isLoggedIn && (
                                        <MenuItem to="/user/logout">{t("logout")}</MenuItem>
                                    )}
                                    {account.isLoggedIn && (
                                        <MenuItem to="/user/my-profile">
                                            <div className="avatar-section desktop">
                                                <h3>{account.account.fullName}</h3>
                                                <img
                                                    src={userProfile.profilePhotoPath || "/default-profile-picture.jpg"}
                                                    alt="user profile avatar"
                                                />
                                            </div>
                                        </MenuItem>
                                    )}
                                    {!account.isLoggedIn && (
                                        <MenuItem to="/user/login">{t("login")}</MenuItem>
                                    )}
                                    <MenuItem>
                                        <select value={languageOption} onChange={changeLanguage}>
                                            <option className="hiddenLanguage" value="en">{t("language")}</option>
                                            <option value="en">English</option>
                                            <option value="hi">हिंदी</option>
                                            <option value="th">ไทย</option>
                                            <option value="my">Bahasa Melayu</option>
                                            <option value="cn">简体中文</option>
                                        </select></MenuItem>
                                </Fragment>
                            }
                        />
                    </Col>
                </Row>
            </Container>
        </header>
    );
};

export default Header;
